import React, { useState } from "react";
import { Library, Gamepad2, StickyNote, Shield, Info } from "lucide-react";
import GameZoneMenu from "./views/GameZoneMenu";
import Biblioteca from "./views/Biblioteca";
import MisNotas from "./views/MisNotas";
import AcercaDeSit from "./views/AcercaDeSit";
import AutoridadesSistema from "./views/AutoridadesSistema";

const SectionTitle = ({ emoji, title }) => (
  <h3 className="text-base sm:text-lg font-bold text-gray-700 dark:text-gray-300 mb-5 flex items-center gap-2 uppercase tracking-widest">
    <span>{emoji}</span> {title}
    <span className="flex-1 h-px bg-gray-200 dark:bg-gray-700 ml-2" />
  </h3>
);

const HubCard = ({ icon: Icon, iconColor, iconBg, title, description, onClick, href }) => {
  const inner = (
    <div className="flex flex-col items-center text-center gap-3 w-full px-2">
      <div className={`p-3 rounded-2xl ${iconBg} flex-shrink-0`}>
        <Icon className={`w-7 h-7 ${iconColor}`} />
      </div>
      <div>
        <h4 className="text-sm font-bold text-gray-800 dark:text-gray-100 leading-snug">
          {title}
        </h4>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );

  const base =
    "group p-5 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md hover:border-indigo-300 dark:hover:border-indigo-600 hover:-translate-y-0.5 transition-all duration-200 flex flex-col items-center justify-center w-full min-h-[140px]";

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={base}>
        {inner}
      </a>
    );
  }
  return (
    <button onClick={onClick} className={base}>
      {inner}
    </button>
  );
};

export default function MultiHubView() {
  const [isLibraryModalOpen, setIsLibraryModalOpen]   = useState(false);
  const [isGameZoneOpen, setIsGameZoneOpen]           = useState(false);
  const [isNotesModalOpen, setIsNotesModalOpen]       = useState(false);
  const [isAuthoritiesModalOpen, setIsAuthoritiesModalOpen] = useState(false);
  const [isAboutModalOpen, setIsAboutModalOpen]       = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 px-4 py-8 sm:px-8 sm:py-10">

      {/* Header */}
      <header className="text-center mb-10 max-w-2xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-600 dark:from-indigo-400 dark:to-purple-400 mb-2">
          MULTIHUB
        </h2>
        <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400">
          Explora todas las funcionalidades integradas de SIT.
        </p>
      </header>

      <div className="max-w-4xl mx-auto space-y-10">

        {/* Plataforma */}
        <section>
          <SectionTitle emoji="🚀" title="Plataforma" />
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            <HubCard
              icon={Gamepad2}
              iconColor="text-red-500"
              iconBg="bg-red-100 dark:bg-red-900/40"
              title="GameZone"
              description="Juegos y desafíos divertidos."
              onClick={() => setIsGameZoneOpen(true)}
            />
            <HubCard
              icon={StickyNote}
              iconColor="text-yellow-500"
              iconBg="bg-yellow-100 dark:bg-yellow-900/40"
              title="Recordatorios"
              description="Organiza ideas y recordatorios."
              onClick={() => setIsNotesModalOpen(true)}
            />
            <HubCard
              icon={Library}
              iconColor="text-green-600"
              iconBg="bg-green-100 dark:bg-green-900/40"
              title="Biblioteca SIT"
              description="Recursos digitales ilimitados."
              onClick={() => setIsLibraryModalOpen(true)}
            />
          </div>
        </section>

        {/* Acerca de SIT */}
        <section>
          <SectionTitle emoji="ℹ️" title="Acerca de SIT" />
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            <HubCard
              icon={Shield}
              iconColor="text-indigo-500"
              iconBg="bg-indigo-100 dark:bg-indigo-900/40"
              title="Autoridades del Sistema"
              description="Equipo detrás de SIT."
              onClick={() => setIsAuthoritiesModalOpen(true)}
            />
            <HubCard
              icon={Info}
              iconColor="text-teal-500"
              iconBg="bg-teal-100 dark:bg-teal-900/40"
              title="Acerca de SIT"
              description="Visión y misión del sistema."
              onClick={() => setIsAboutModalOpen(true)}
            />
          </div>
        </section>

      </div>

      {/* Modals */}
      <GameZoneMenu     isOpen={isGameZoneOpen}        onClose={() => setIsGameZoneOpen(false)} />
      <MisNotas         isOpen={isNotesModalOpen}       onClose={() => setIsNotesModalOpen(false)} />
      <Biblioteca       isOpen={isLibraryModalOpen}    onClose={() => setIsLibraryModalOpen(false)} />
      <AutoridadesSistema isOpen={isAuthoritiesModalOpen} onClose={() => setIsAuthoritiesModalOpen(false)} />
      <AcercaDeSit      isOpen={isAboutModalOpen}      onClose={() => setIsAboutModalOpen(false)} />
    </div>
  );
}
